import { Component, OnInit, Optional, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router  } from '@angular/router';
import { SharedService } from '../../_service/shared.service';
import { LeadsService } from '../../_service/leads.service';
import { DentalService } from '../../_service/dental.service';
import { FormControl, FormGroupDirective, FormBuilder, FormGroup, NgForm, Validators, FormArray } from '@angular/forms';
declare var $: any;
@Component({
  selector: 'app-scan-payment-modal',
  templateUrl: './scan-payment-modal.component.html',
  styleUrls: ['./scan-payment-modal.component.css']
})
export class ScanPaymentModalComponent implements OnInit {

  lead_id;payment_type;scan_id;
  PaymentLinkForm: FormGroup;
  copypaymentlink:any;
  show_copy:boolean=false;
  loading:boolean = false;
  constructor(public dialogRef: MatDialogRef<ScanPaymentModalComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,private router:Router,private sharedapi:SharedService, private leadapi:LeadsService,private formBuilder: FormBuilder,private dentalapi:DentalService) { 
     
    this.lead_id = data.lead_id;
    this.scan_id = data.scan_id;
    this.payment_type = data.type;
    this.PaymentLinkForm = this.formBuilder.group({
      'patient_name' : [null, Validators.required],
      'mobile' : [null, Validators.required],
      'amount' : [null, Validators.required],
      'description' : [null, Validators.required],
      'leadid' : [null, Validators.required],
      'payment_type' : this.payment_type,
      'lab_lead_id' :[null]
    })
    
  }

  copyToClipboard(element) {
    element.select();
    document.execCommand('copy');
    this.sharedapi.presentToast('Link copied to clipboard.');
  }

  ngOnInit(): void {
    this.getScanDetails();
  }

  closeDialog() {
    this.dialogRef.close({ event: 'close', data: '' });
  }
  getScanDetails(){
    
    this.dentalapi.getLeadScanData(this.lead_id,this.scan_id).subscribe((data:any) =>{
      if(data.status)
      {
        let patientID = data.lead.glamyo_patient_id;
        let patient = data.lead.lead_name;
        let bdName = data.lead.name;
        let details = 'PatientID: '+patientID+', PatientName: '+patient+', BdName: '+bdName;
        this.PaymentLinkForm.controls['patient_name'].setValue(data.lead.lead_name);
        this.PaymentLinkForm.controls['mobile'].setValue(data.lead.mobile);
        this.PaymentLinkForm.controls['description'].setValue(details);
        this.PaymentLinkForm.controls['leadid'].setValue(this.lead_id);
        
      }
      else{
        if(data.error_type!='no')
        this.sharedapi.presentToast('Error Occured');
      }
    },
    error => {
        this.sharedapi.checkError(error);
    });
  }

  sendPaymentLink(){
    this.loading = true;
    if (this.PaymentLinkForm.invalid) {
      this.loading = false;
      return;
    }
    let formData = this.PaymentLinkForm.value
    
    this.leadapi.share_payment_link(formData).subscribe((data:any) =>{
      this.loading = false;
      if (data.data.hasOwnProperty("error")) {
        this.sharedapi.presentToast(data.data.error.description);
      }else{
        this.sharedapi.presentToast("Payment Link Sent Successfully!");
        this.show_copy = true;
        
        this.copypaymentlink = data.data.short_url;
      }
    },
    error => {
        this.sharedapi.checkError(error);
    });
  }
  


}